import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["caption", "imageIds", "isCaptionDisplayed", "VariantComponent"];
import React from 'react';
import PropTypes from 'prop-types';
import CarouselImage from './CarouselImage';
import CarouselRender from './CarouselRender';
import { useCarouselNavigation } from './hooks/useCarouselNavigation';
import { getDisplayCountData } from '../../helpers';
const Carousel = props => {
  const {
      caption,
      imageIds,
      isCaptionDisplayed,
      VariantComponent
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const navigationProps = useCarouselNavigation(props);
  if (!imageIds || !imageIds.length) return null;
  const shouldDisplayCaption = isCaptionDisplayed && caption;
  const {
    shouldDisplayCount,
    countMessage
  } = getDisplayCountData(navigationProps.showCount, imageIds);
  const ComponentToRender = VariantComponent || CarouselRender;
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    caption: caption,
    imageIds: imageIds,
    CarouselImage: CarouselImage,
    shouldDisplayCaption: shouldDisplayCaption,
    shouldDisplayCount: shouldDisplayCount,
    countMessage: countMessage
  }, navigationProps, otherProps));
};
Carousel.propTypes = {
  caption: PropTypes.string,
  imageIds: PropTypes.array,
  isCaptionDisplayed: PropTypes.bool,
  VariantComponent: PropTypes.func
};
Carousel.defaultProps = {
  VariantComponent: null,
  caption: '',
  imageIds: [],
  isCaptionDisplayed: false
};
export default Carousel;
//# sourceMappingURL=Carousel.js.map